/**
 * Browser file helpers of the Library (W2-10 projects-data): offer a Blob as a download.
 */

/** Saves `blob` under `fileName` through a temporary object URL (no-op where object URLs do not exist). */
export function downloadBlob(blob: Blob, fileName: string): void {
  if (typeof URL.createObjectURL !== 'function') return;
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  a.rel = 'noopener';
  a.style.display = 'none';
  document.body.append(a);
  a.click();
  a.remove();
  // Give the browser time to start the download before the URL is released.
  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 30_000);
}

/** File extension for a Blob by its type. */
export function extensionFor(type: string): string {
  if (type.includes('zip')) return 'zip';
  if (type.includes('json')) return 'json';
  if (type.startsWith('text/')) return 'txt';
  return 'bin';
}
